import Vue from 'vue'
import store from './store'
Vue.directive('has', {
  inserted: function (el, binding) {
    if (!has(binding.value)) {
      el.parentNode.removeChild(el)
    }
  }
})
function has (permission) {
  const routerSystemKey = permissions.clickMenu
  const ps = permissions.currentLoginDepartment.departmentSystemAuths.filter(m => m.authKey === routerSystemKey)[0].authResourceKeys
  if (ps !== undefined && ps.indexOf(permission) >= 0) {
    return true
  }
  return false
}
const permissions = store.state.user
export default permissions.currentLoginDepartment



// WEBPACK FOOTER //
// ./src/permissions-list.js